import { render, staticRenderFns } from "./ConnectWalletNeon.vue?vue&type=template&id=4c96ad10"
import script from "./ConnectWalletNeon.vue?vue&type=script&lang=ts"
export * from "./ConnectWalletNeon.vue?vue&type=script&lang=ts"
import style0 from "./ConnectWalletNeon.vue?vue&type=style&index=0&id=4c96ad10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports